export const style = {
  table: {
    sx: {
      '& .MuiTableCell-head': {
        padding: '8px',
        paddingRight: '0px',
      },
    },
  },
  card: {
    cardHeader: {
      sx: {
        py: 3,
      },
      typography: {
        variant: 'h6',
        color: 'primary.text',
      },
      typography2: {
        sx: {
          color: 'action.active',
        },
      },
      box: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      },
    },
    sx: {
      m: 0,
    },
    style: {
      position: 'relative',
    },
  },
  cardDisabled: {
    backgroundColor: '#F3F4F6',
    pointerEvents: 'none',
  },
  boxContainer: {
    sx: {
      maxWidth: 'lg',
    },
  },
  Box: {
    sx: {
      maxWidth: 'lg',
      mt: 3,
    },
  },
} as const;
